// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"179":"main","2781":"components-VideoPlayer-PlayerDesktop","8282":"components-VideoPlayer-PlayerMobile"}[chunkId] + "-" + {"179":"fb1587bd","2781":"c84c4996","8282":"eedfd49b"}[chunkId] + ".css";
};